import loginContent from './content/login.json';

const loginMock = {
    layoutType: 1,
    data: {
        name: 'login',
        layoutType: 1,
        areasList: [
            {
                id: 'login-page-area',
                name: 'Content',
                componentName: 'Comp:LoginPage',
                content: JSON.stringify(loginContent),
            },
        ],
    },
};

export default loginMock;
